import { createSlice } from "@reduxjs/toolkit";

const initialScrimTabUserProfileNewState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  requestLogsList: [],
  gameList: [],
  company: [],
  gameTypeList: [],
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const ScrimsTabUserProfileNewSlice = createSlice({

  name: "scrimTabUserProfile",
  initialState: initialScrimTabUserProfileNewState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    emptyList: (state, action) => {
      state.error = null;
      state.totalCount=0;
      state.requestLogsList = []
    },

    usersLogsList: (state, action) => {
      console.log(action.payload);
      state.listLoading = false;
      state.requestLogsList = action.payload.data;
      state.totalCount = action.payload.totalRecord;
    },
    gameList: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.gameList = entities;
    },
    gameTypeList: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.gameTypeList = entities;
    },
    company: (state, action) => {
      const { totalCount, entities } = action.payload;
      console.log(entities)
      state.listLoading = false;
      state.error = null;
      state.company = entities;
      // state.totalCount = totalCount;
  },
  }
});
